// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"styles_descriptionContainer__tY-Yp","descriptionCard":"styles_descriptionCard__aXrT2"};